<template>
  <div class="independent-wrapper">
    <div class="content">
      <div class="title">
        <span class="border"></span>
        <i class="el-icon-location-outline"></i> 内容管理 &gt; 首页管理
      </div>
      <div class="contentLeft">
        <el-tabs v-model="activeTab" @tab-change="onTabChange" class="cms-tabs">
          <el-tab-pane label="Hero 轮播" name="hero"></el-tab-pane>
          <el-tab-pane label="快速导航" name="quicknav"></el-tab-pane>
          <el-tab-pane label="品牌数据" name="stat"></el-tab-pane>
        </el-tabs>

        <div class="toolbar">
          <el-button class="addBtn" type="primary" @click="openAdd">新增</el-button>
          <el-button :disabled="!sortDirty" @click="saveSort">保存排序</el-button>
          <span v-if="sortDirty" class="hint">排序已修改，请保存</span>
        </div>

        <div class="table-con">
          <el-table
            :header-cell-style="{ background: '#f7f7f7', color: '#333' }"
            :data="tableData"
            v-loading="loading"
            row-key="id"
            style="width: 100%"
          >
            <el-table-column align="center" label="排序" width="120">
              <template #default="{ $index }">
                <div class="sort-cell">
                  <el-button size="small" :disabled="$index === 0" @click="moveRow($index, -1)">↑</el-button>
                  <el-button size="small" :disabled="$index === tableData.length - 1" @click="moveRow($index, 1)">↓</el-button>
                </div>
              </template>
            </el-table-column>
            <el-table-column v-if="activeTab === 'quicknav'" align="center" label="图标" width="80">
              <template #default="{ row }">
                <img v-if="row.iconUrl" :src="resolveImg(row.iconUrl)" class="thumb" @error="onImgError" />
                <span v-else class="no-img">无</span>
              </template>
            </el-table-column>
            <el-table-column v-if="activeTab === 'hero'" align="center" label="类型" width="90">
              <template #default="{ row }">
                <span v-if="row.theme === 'image'" style="color: #679ff6">纯图片</span>
                <span v-else>主题{{ (row.theme || 'a').toUpperCase() }}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" :label="activeTab === 'stat' ? '标签' : '标题'">
              <template #default="{ row }">
                <span v-if="activeTab === 'hero' && row.theme === 'image'" style="color: #999">—</span>
                <span v-else>{{ row.title }}</span>
              </template>
            </el-table-column>
            <el-table-column v-if="activeTab === 'hero'" align="center" label="副文案" show-overflow-tooltip>
              <template #default="{ row }">
                <span v-if="row.theme === 'image'" style="color: #999">—</span>
                <span v-else>{{ row.subtitle }}</span>
              </template>
            </el-table-column>
            <el-table-column v-if="activeTab === 'hero'" align="center" label="徽章" show-overflow-tooltip>
              <template #default="{ row }">
                <span v-if="row.theme === 'image'" style="color: #999">—</span>
                <span v-else>{{ row.badge }}</span>
              </template>
            </el-table-column>
            <el-table-column v-if="activeTab === 'stat'" align="center" label="数值" width="100">
              <template #default="{ row }">{{ row.statValue }}{{ row.statUnit }}</template>
            </el-table-column>
            <el-table-column v-if="activeTab !== 'stat'" align="center" label="跳转" prop="action" width="100"></el-table-column>
            <el-table-column align="center" label="状态" width="100">
              <template #default="{ row }">
                <span :style="{ color: row.status === 1 ? '#67c23a' : '#999' }">
                  {{ row.status === 1 ? '启用' : '隐藏' }}
                </span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="操作" width="200">
              <template #default="{ row }">
                <span class="editor" @click="openEdit(row)">编辑</span>
                <span class="editor" @click="toggleStatus(row)">{{ row.status === 1 ? '隐藏' : '启用' }}</span>
                <el-popconfirm title="确定删除该条记录?" @confirm="doDelete(row)">
                  <template #reference>
                    <span class="del">删除</span>
                  </template>
                </el-popconfirm>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>

    <!-- 新增/编辑 dialog -->
    <el-dialog
      :title="(addOrEdit === 'add' ? '新增' : '编辑') + tabLabel"
      v-model="dialogVisible"
      width="640px"
      center
      :close-on-click-modal="false"
    >
      <el-form ref="cmsForm" :model="formData" :rules="formRules" label-width="100px">
        <!-- Hero -->
        <template v-if="activeTab === 'hero'">
          <el-form-item label="幻灯类型" prop="slideMode">
            <el-radio-group v-model="formData.slideMode">
              <el-radio label="rich">图文卡片</el-radio>
              <el-radio label="image">纯图片</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="formData.slideMode === 'image' ? '图片' : '背景图'" prop="imageUrl">
            <el-upload
              :show-file-list="false"
              :http-request="(o) => doUpload(o, 'imageUrl', SPECS.HERO_BG)"
              accept=".png,.PNG,.jpg,.JPG,.jpeg,.JPEG"
            >
              <el-button>上传图片</el-button>
            </el-upload>
            <div class="upload-tip">
              {{ formData.slideMode === 'image'
                ? '建议 1080×720 PNG/JPG，3:2 横图，≤500KB'
                : '建议 1080×720 PNG/JPG，3:2 横图，≤500KB；可选，留空降级渐变' }}
            </div>
            <div v-if="formData.imageUrl" class="upload-preview">
              <img :src="resolveImg(formData.imageUrl)" @error="onImgError" />
              <span class="del-img" @click="formData.imageUrl = ''">移除</span>
            </div>
          </el-form-item>
          <template v-if="formData.slideMode === 'rich'">
            <el-form-item label="主题" prop="theme">
              <el-select v-model="formData.theme" placeholder="选择主题色板">
                <el-option label="A 主色（健康）" value="a"></el-option>
                <el-option label="B 副色（识体质）" value="b"></el-option>
                <el-option label="C 强调（产地）" value="c"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="顶部徽章" prop="badge">
              <el-input v-model="formData.badge" placeholder="如：春季养护季 · Spring Edit"></el-input>
            </el-form-item>
            <el-form-item label="标题前缀" prop="titlePrefix">
              <el-input v-model="formData.titlePrefix" placeholder="如：开启您的"></el-input>
            </el-form-item>
            <el-form-item label="高亮段" prop="title">
              <el-input v-model="formData.title" placeholder="如：健康"></el-input>
            </el-form-item>
            <el-form-item label="标题后缀" prop="titleSuffix">
              <el-input v-model="formData.titleSuffix" placeholder="如：之旅"></el-input>
            </el-form-item>
            <el-form-item label="水印汉字" prop="watermark">
              <el-input v-model="formData.watermark" maxlength="2" placeholder="如：養"></el-input>
            </el-form-item>
            <el-form-item label="副文案" prop="subtitle">
              <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" v-model="formData.subtitle"></el-input>
            </el-form-item>
            <el-form-item label="CTA 文字" prop="ctaText">
              <el-input v-model="formData.ctaText" placeholder="如：开启健康旅程"></el-input>
            </el-form-item>
          </template>
          <el-form-item label="跳转动作" prop="action">
            <el-select v-model="formData.action" placeholder="选择跳转目标">
              <el-option label="不跳转" value="none"></el-option>
              <el-option label="商城首页" value="mall"></el-option>
              <el-option label="舌面检测" value="detection"></el-option>
              <el-option label="关于我们" value="about"></el-option>
              <el-option label="商品详情" value="product"></el-option>
              <el-option label="自定义 URL" value="external"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="formData.action === 'product'" label="选择商品" prop="targetUrl">
            <el-select
              v-model="formData.targetUrl"
              filterable
              remote
              clearable
              :remote-method="searchProducts"
              :loading="productSearchLoading"
              placeholder="输入商品名搜索"
              style="width: 100%"
            >
              <el-option
                v-for="p in productOptions"
                :key="p.id"
                :label="p.name"
                :value="String(p.id)"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="formData.action === 'external'" label="自定义 URL" prop="targetUrl">
            <el-input v-model="formData.targetUrl" placeholder="https://..."></el-input>
          </el-form-item>
        </template>

        <!-- Quicknav -->
        <template v-if="activeTab === 'quicknav'">
          <el-form-item label="标签文字" prop="title">
            <el-input v-model="formData.title" placeholder="如：商城产品"></el-input>
          </el-form-item>
          <el-form-item label="图标" prop="iconUrl">
            <el-upload
              :show-file-list="false"
              :http-request="(o) => doUpload(o, 'iconUrl', SPECS.QUICKNAV_ICON)"
              accept=".png,.PNG,.jpg,.JPG,.jpeg,.JPEG,.svg"
            >
              <el-button>上传图标</el-button>
            </el-upload>
            <div class="upload-tip">建议 144×144 PNG（透明背景），1:1 正方，≤80KB</div>
            <div v-if="formData.iconUrl" class="upload-preview">
              <img :src="resolveImg(formData.iconUrl)" @error="onImgError" />
              <span class="del-img" @click="formData.iconUrl = ''">移除</span>
            </div>
          </el-form-item>
          <el-form-item label="跳转动作" prop="action">
            <el-select v-model="formData.action" placeholder="选择跳转目标">
              <el-option label="商城首页" value="mall"></el-option>
              <el-option label="产品资质" value="qualification"></el-option>
              <el-option label="关于我们" value="about"></el-option>
              <el-option label="联系客服" value="service"></el-option>
              <el-option label="自定义 URL" value="external"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="formData.action === 'external'" label="自定义 URL" prop="targetUrl">
            <el-input v-model="formData.targetUrl" placeholder="https://..."></el-input>
          </el-form-item>
        </template>

        <!-- Stat -->
        <template v-if="activeTab === 'stat'">
          <el-form-item label="标签" prop="title">
            <el-input v-model="formData.title" placeholder="如：服务用户"></el-input>
          </el-form-item>
          <el-form-item label="数值" prop="statValue">
            <el-input v-model="formData.statValue" placeholder="如：10"></el-input>
          </el-form-item>
          <el-form-item label="单位/后缀" prop="statUnit">
            <el-input v-model="formData.statUnit" placeholder="如：万+"></el-input>
          </el-form-item>
        </template>
      </el-form>
      <template #footer>
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submit" :loading="submitting">确定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import axiosconf from '../../api/axiosconf'
import * as cmsApi from '../../api/cms'
import { SPECS, checkSpec } from '@/utils/imageSpec'

const TAB_LABEL = { hero: 'Hero 轮播', quicknav: '快速导航', stat: '品牌数据' }

// 患者端内置图标走本地打包资源（/static/...），后端素材服务器没有这些图，
// 桌面端映射到项目本地同名副本，否则预览破图。
const BUILTIN_ICONS = {
  '/static/images/service/mall.png': require('@/assets/quicknav/mall.png'),
  '/static/images/service/cert.png': require('@/assets/quicknav/cert.png'),
  '/static/images/service/about.png': require('@/assets/quicknav/about.png'),
  '/static/images/service/service.png': require('@/assets/quicknav/service.png'),
}

// 加载失败兜底占位（中性灰图标），避免出现浏览器默认破图
const FALLBACK_IMG =
  'data:image/svg+xml;charset=utf8,' +
  encodeURIComponent(
    '<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48">' +
      '<rect width="48" height="48" rx="6" fill="#f2f3f5"/>' +
      '<path d="M14 32l7-9 5 6 4-5 6 8z" fill="#c8ccd4"/>' +
      '<circle cx="18" cy="17" r="3" fill="#c8ccd4"/>' +
    '</svg>'
  )

function emptyForm(tab) {
  if (tab === 'hero') {
    return {
      id: '', blockType: 'hero', sort: 0, status: 1,
      slideMode: 'rich',
      theme: 'a', badge: '', titlePrefix: '', title: '', titleSuffix: '',
      watermark: '', subtitle: '', ctaText: '', imageUrl: '',
      action: 'mall', targetUrl: '',
    }
  }
  if (tab === 'quicknav') {
    return {
      id: '', blockType: 'quicknav', sort: 0, status: 1,
      title: '', iconUrl: '', action: 'mall', targetUrl: '',
    }
  }
  return {
    id: '', blockType: 'stat', sort: 0, status: 1,
    title: '', statValue: '', statUnit: '',
  }
}

export default {
  data() {
    return {
      SPECS,
      activeTab: 'hero',
      tableData: [],
      loading: false,
      sortDirty: false,
      dialogVisible: false,
      submitting: false,
      addOrEdit: 'add',
      formData: emptyForm('hero'),
      productOptions: [],
      productSearchLoading: false,
    }
  },
  computed: {
    tabLabel() {
      return TAB_LABEL[this.activeTab]
    },
    formRules() {
      const tab = this.activeTab
      const isImageHero = tab === 'hero' && this.formData.slideMode === 'image'
      const rules = {}
      if (tab === 'hero') {
        rules.imageUrl = isImageHero
          ? [{ required: true, message: '请上传图片', trigger: 'change' }]
          : []
        if (!isImageHero) {
          rules.title = [{ required: true, message: '请输入标题', trigger: 'blur' }]
          rules.theme = [{ required: true, message: '请选择主题', trigger: 'change' }]
        }
        if (this.formData.action === 'product') {
          rules.targetUrl = [{ required: true, message: '请选择商品', trigger: 'change' }]
        } else if (this.formData.action === 'external') {
          rules.targetUrl = [{ required: true, message: '请填写跳转 URL', trigger: 'blur' }]
        }
      } else if (tab === 'quicknav') {
        rules.title = [{ required: true, message: '请输入标题', trigger: 'blur' }]
      } else if (tab === 'stat') {
        rules.title = [{ required: true, message: '请输入标题', trigger: 'blur' }]
        rules.statValue = [{ required: true, message: '请输入数值', trigger: 'blur' }]
        rules.statUnit = [{ required: true, message: '请输入单位', trigger: 'blur' }]
      }
      return rules
    },
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    resolveImg(url) {
      if (!url) return ''
      if (BUILTIN_ICONS[url]) return BUILTIN_ICONS[url]
      if (/^https?:\/\//.test(url)) return url
      if (url.startsWith('/')) return cmsApi.imageBaseUrl.replace(/\/$/, '') + url
      return cmsApi.imageBaseUrl + url
    },
    onImgError(e) {
      const img = e && e.target
      if (!img || img.dataset.fallback) return
      img.dataset.fallback = '1'
      img.src = FALLBACK_IMG
    },
    async fetchList() {
      this.loading = true
      this.sortDirty = false
      try {
        const res = await cmsApi.homeList(this.activeTab)
        if (res.data && res.data.code === 0) {
          this.tableData = (res.data.data || []).slice().sort((a, b) => a.sort - b.sort)
        } else {
          this.$message.error(res.data?.msg || '加载失败')
        }
      } catch (e) {
        this.$message.error('网络异常')
      } finally {
        this.loading = false
      }
    },
    onTabChange() {
      this.fetchList()
    },
    moveRow(index, dir) {
      const target = index + dir
      if (target < 0 || target >= this.tableData.length) return
      const arr = this.tableData.slice()
      const tmp = arr[index]
      arr[index] = arr[target]
      arr[target] = tmp
      this.tableData = arr
      this.sortDirty = true
    },
    async saveSort() {
      const items = this.tableData.map((row, idx) => ({ id: row.id, sort: idx + 1 }))
      try {
        const res = await cmsApi.homeSort(items)
        if (res.data && res.data.code === 0) {
          this.$message.success('排序已保存')
          this.fetchList()
        } else {
          this.$message.error(res.data?.msg || '保存失败')
        }
      } catch (e) {
        this.$message.error('网络异常')
      }
    },
    openAdd() {
      this.addOrEdit = 'add'
      this.formData = emptyForm(this.activeTab)
      this.productOptions = []
      this.dialogVisible = true
      this.$nextTick(() => this.$refs.cmsForm?.clearValidate())
    },
    openEdit(row) {
      this.addOrEdit = 'edit'
      const merged = { ...emptyForm(this.activeTab), ...row }
      if (this.activeTab === 'hero') {
        merged.slideMode = row.theme === 'image' ? 'image' : 'rich'
        if (merged.slideMode === 'image') merged.theme = 'a'
      }
      this.formData = merged
      this.productOptions = []
      if (this.activeTab === 'hero' && merged.action === 'product' && merged.targetUrl) {
        this.loadProductOption(merged.targetUrl)
      }
      this.dialogVisible = true
      this.$nextTick(() => this.$refs.cmsForm?.clearValidate())
    },
    async loadProductOption(productId) {
      try {
        const res = await axiosconf.applicationJson(`/mall/admin/product/detail/${productId}`, {})
        if (res.data && res.data.code === 0 && res.data.data) {
          this.productOptions = [{ id: res.data.data.id, name: res.data.data.name }]
        }
      } catch (e) {
        // 静默失败：用户可重新搜索
      }
    },
    async searchProducts(query) {
      if (!query || !query.trim()) {
        this.productOptions = []
        return
      }
      this.productSearchLoading = true
      try {
        const res = await axiosconf.applicationJson('/mall/admin/product/list', {
          keyword: query.trim(),
          status: 1,
          pageNum: 1,
          pageSize: 20,
        })
        if (res.data && res.data.code === 0) {
          const records = res.data.data?.records || res.data.data?.list || []
          this.productOptions = records.map((r) => ({ id: r.id, name: r.name }))
        }
      } catch (e) {
        this.productOptions = []
      } finally {
        this.productSearchLoading = false
      }
    },
    async toggleStatus(row) {
      const next = row.status === 1 ? 0 : 1
      try {
        const res = await cmsApi.homeToggle(row.id, next)
        if (res.data && res.data.code === 0) {
          this.$message.success(next === 1 ? '已启用' : '已隐藏')
          this.fetchList()
        } else {
          this.$message.error(res.data?.msg || '操作失败')
        }
      } catch (e) {
        this.$message.error('网络异常')
      }
    },
    async doDelete(row) {
      try {
        const res = await cmsApi.homeDelete(row.id)
        if (res.data && res.data.code === 0) {
          this.$message.success('删除成功')
          this.fetchList()
        } else {
          this.$message.error(res.data?.msg || '删除失败')
        }
      } catch (e) {
        this.$message.error('网络异常')
      }
    },
    async doUpload(option, field, spec = { maxKB: 10240 }) {
      const file = option.file
      if (!file) return
      if (!(await checkSpec(this, file, spec))) return
      try {
        const res = await cmsApi.uploadImage(file)
        const path = res.data?.data || res.data?.msg
        if (res.data && res.data.code === 0 && path) {
          this.formData[field] = path
          this.$message.success('上传成功')
        } else {
          this.$message.error(res.data?.msg || '上传失败')
        }
      } catch (e) {
        this.$message.error('上传失败')
      }
    },
    submit() {
      this.$refs.cmsForm.validate(async (valid) => {
        if (!valid) return
        this.submitting = true
        try {
          const payload = { ...this.formData, blockType: this.activeTab }
          if (this.activeTab === 'hero') {
            if (payload.slideMode === 'image') {
              payload.theme = 'image'
              payload.badge = ''
              payload.titlePrefix = ''
              payload.title = ''
              payload.titleSuffix = ''
              payload.watermark = ''
              payload.subtitle = ''
              payload.ctaText = ''
            }
            delete payload.slideMode
          }
          if (this.addOrEdit === 'add') delete payload.id
          const res = this.addOrEdit === 'add'
            ? await cmsApi.homeAdd(payload)
            : await cmsApi.homeEdit(payload)
          if (res.data && res.data.code === 0) {
            this.$message.success(this.addOrEdit === 'add' ? '新增成功' : '编辑成功')
            this.dialogVisible = false
            this.fetchList()
          } else {
            this.$message.error(res.data?.msg || '操作失败')
          }
        } catch (e) {
          this.$message.error('网络异常')
        } finally {
          this.submitting = false
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
@import "../../../static/css/layout.less";

.independent-wrapper {
  width: 100%;
  height: 100%;
  overflow-y: auto;
}
.content {
  padding: 20px;
  .title {
    font-size: 14px;
    color: #333;
    margin-bottom: 20px;
    .border {
      display: inline-block;
      width: 3px;
      height: 14px;
      background: #679ff6;
      margin-right: 8px;
      vertical-align: middle;
    }
  }
}
.cms-tabs {
  margin-bottom: 12px;
}
.toolbar {
  margin-bottom: 12px;
  .addBtn {
    background: #679ff6;
    border-color: #679ff6;
    color: #fff;
  }
  .hint {
    margin-left: 12px;
    color: #e6a23c;
    font-size: 12px;
  }
}
.table-con {
  .thumb {
    width: 36px;
    height: 36px;
    object-fit: contain;
    background: #f7f7f7;
    border-radius: 4px;
  }
  .no-img {
    color: #ccc;
  }
  .sort-cell {
    display: flex;
    justify-content: center;
    gap: 4px;
  }
  .editor {
    color: #679ff6;
    cursor: pointer;
    margin-right: 10px;
  }
  .del {
    color: #f56c6c;
    cursor: pointer;
  }
}
.upload-preview {
  margin-top: 8px;
  display: flex;
  align-items: center;
  gap: 12px;
  img {
    max-width: 120px;
    max-height: 80px;
    border: 1px solid #eee;
    border-radius: 4px;
  }
  .del-img {
    color: #f56c6c;
    cursor: pointer;
    font-size: 12px;
  }
}
.hint {
  color: #999;
  font-size: 12px;
  margin-left: 12px;
}
.upload-tip {
  color: #909399;
  font-size: 12px;
  margin-top: 4px;
  line-height: 1.5;
}
</style>
